import { ATTRIBUTE_CREATE_FAILURE, ATTRIBUTE_CREATE_REQUEST, ATTRIBUTE_CREATE_RESET, ATTRIBUTE_CREATE_SUCCESS, ATTRIBUTE_DELETE_FAIL, ATTRIBUTE_DELETE_REQUEST, ATTRIBUTE_DELETE_RESET, ATTRIBUTE_DELETE_SUCCESS, ATTRIBUTE_GET_FAILURE, ATTRIBUTE_GET_REQUEST, ATTRIBUTE_GET_SUCCESS, ATTRIBUTE_LIST_FAILURE, ATTRIBUTE_LIST_REQUEST, ATTRIBUTE_LIST_SUCCESS, ATTRIBUTE_UPDATE_FAILURE, ATTRIBUTE_UPDATE_REQUEST, ATTRIBUTE_UPDATE_RESET, ATTRIBUTE_UPDATE_SUCCESS } from "../constants/attributeConstants";

export const attributeCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTRIBUTE_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ATTRIBUTE_CREATE_SUCCESS:
      return {
        loading: false,
        attribute: action.payload,
        success: true,
      };
    case ATTRIBUTE_CREATE_FAILURE:
      return {
        loading: false,
        error: action.payload,
      };
    case ATTRIBUTE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const attributeListReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTRIBUTE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ATTRIBUTE_LIST_SUCCESS:
      return {
        loading: false,
        attributes: action.payload,
        success: true,
      };
    case ATTRIBUTE_LIST_FAILURE:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const attributeGetReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTRIBUTE_GET_REQUEST:
      return { loading: true, ...state };
    case ATTRIBUTE_GET_SUCCESS:
      return { loading: false, attribute: action.payload, success: true };
    case ATTRIBUTE_GET_FAILURE:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const atttributeUpdateReducer = (state = { brand: {} }, action) => {
  switch (action.type) {
    case ATTRIBUTE_UPDATE_REQUEST:
      return { loading: true };
    case ATTRIBUTE_UPDATE_SUCCESS:
      return { loading: false, success: true, attribute: action.payload };
    case ATTRIBUTE_UPDATE_FAILURE:
      return { loading: false, error: action.payload };
    case ATTRIBUTE_UPDATE_RESET:
      return { ATTRIBUTE: {} };
    default:
      return state;
  }
};

export const attributeDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case ATTRIBUTE_DELETE_REQUEST:
      return { loading: true };
    case ATTRIBUTE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case ATTRIBUTE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
    case ATTRIBUTE_DELETE_RESET:
      return {};
  }
};
